import { LinkItem } from "@comparaonline/ui-filter-list";
import { StyleRulesCallback, withStyles, WithStyles } from "@material-ui/core/styles";
import cx from "classnames";
import React from "react";
import { Link } from "../../../../../routes";

const styles: StyleRulesCallback = theme => ({
  highlight: {
    fontWeight: theme.typography.fontWeightMedium
  }
});

interface IFilterLinkProps extends WithStyles<typeof styles> {
  highlight: boolean;
  title: React.ReactText;
  url: string;
}

export const BaseFilterLink: React.FC<IFilterLinkProps> = ({ highlight, classes, title, url }) => (
  <Link route={url} shallow={true} passHref={true} scroll={false}>
    <LinkItem className={cx({ [classes.highlight]: highlight })} title={title} />
  </Link>
);

export const FilterLink = withStyles(styles)(BaseFilterLink);
